import "./polyfills.js";
import "./robots.txt";

import "normalize.css";
import "styles/main.scss";

import React from "react";
import ReactDom from "react-dom";
import { Provider } from "react-redux";
import { HelmetProvider } from "react-helmet-async";
import { ApolloProvider } from "react-apollo";
import { ApolloClient } from "apollo-client";
import { InMemoryCache } from "apollo-cache-inmemory";
import { HttpLink } from "apollo-link-http";
import { CookiesProvider } from "react-cookie";

import configureStore from "./store/configureStore";
import { typeDefs } from "./resolvers";
import App from "./components/App";
import { GRAPHQL_ROOT } from "config/constants";
import fragmentMatcher from "utils/apollo/fragmentMatcher";
import { ENABLE_APOLLO_DEVTOOLS } from "config/constants";
import pkg from "../package.json";

if (typeof window !== "undefined") {
  const preloadedState = window.__PRELOADED_STATE__;
  delete window.__PRELOADED_STATE__;

  const store = configureStore(preloadedState);

  const cache = new InMemoryCache({ fragmentMatcher }).restore(
    window.__APOLLO_STATE__
  );
  const charonClient = new ApolloClient({
    cache,
    link: new HttpLink({
      uri: GRAPHQL_ROOT,
    }),
    connectToDevTools: ENABLE_APOLLO_DEVTOOLS,
    name: "platform-site-client-side",
    version: pkg.version,
    resolvers: {},
    typeDefs,
  });

  const render = () => {
    (preloadedState ? ReactDom.hydrate : ReactDom.render)(
      <CookiesProvider>
        <ApolloProvider client={charonClient}>
          <HelmetProvider>
            <Provider store={store}>
              <App />
            </Provider>
          </HelmetProvider>
        </ApolloProvider>
      </CookiesProvider>,
      document.getElementById("app")
    );
  };

  if (module.hot) {
    module.hot.accept("./components/App", () => {
      render();
    });
  }

  render();
}
